export default __webpack_public_path__ + "static/media/rei.2327838b.svg";